'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider
    .state('admin', {
      abstract: true,
      url: '/admin',
      template: require('./admin.html'),
      controller: 'AdminController',
      controllerAs: 'AdminCtrl'
    })
    .state('admin.users', {
      url: '/users?_pageNum&_pageSize&_sortyBy&name&email&role',
      template: require('./partial/users.partial.html'),
      controller: 'UsersController',
      controllerAs: 'UsersCtrl',
      authenticate: 'admin'
    })
    .state('admin.companyGLs', {
      url: '/companyGLs?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
      template: require('./partial/companyGLs.partial.html'),
      controller: 'CompanyGLsController',
      controllerAs: 'CompanyGLsCtrl',
      authenticate: 'admin'
    })
    .state('admin.accountingUnits', {
      url: '/accountingUnits?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
      template: require('./partial/accountingUnits.partial.html'),
      controller: 'AccountingUnitsController',
      controllerAs: 'AccountingUnitsCtrl',
      authenticate: 'admin'
    })
    .state('admin.locationCodes', {
      url: '/locationCodes?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
      template: require('./partial/locationCodes.partial.html'),
      controller: 'LocationCodesController',
      controllerAs: 'LocationCodesCtrl',
      authenticate: 'admin'
    })
    .state('admin.addresses', {
      url: '/addresses?_pageNum&_pageSize&_sortyBy&name&facilityName&areaName&costCenter&city&state',
      template: require('./partial/companyAddresses.partial.html'),
      controller: 'CompanyAddressesController',
      controllerAs: 'CompanyAddressesCtrl',
      authenticate: 'admin'
    })
    .state('admin.jobClass', {
      url: '/jobClass?_pageNum&_pageSize&_sortyBy&jobCode&JobClass',
      template: require('./partial/jobClass.partial.html'),
      controller: 'JobClassController',
      controllerAs: 'JobClassCtrl',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.routes.js